import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Location } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';
import { SiteContext } from '../../contexts/site';
import { getPages } from '../../contentful/page-lookup';
import {
  Container, NavContainer, SiteTitle, NavBuckets, Bucket,
  NavLink, SectionLink, ChildBucket, SinglePageBucket, SinglePageContainer,
} from './primary-nav-css';

export const PrimaryNavigation = ({ singlePages, pagePath }) => {
  const { primaryNavOpen, setPrimaryNavOpen } = useContext(SiteContext);
  const pages = getPages();
  const rootPage = pages.tree[0];

  return (
    <Container primaryNavOpen={primaryNavOpen}>
      <SiteTitle to="/">Brand Central</SiteTitle>
      <NavContainer>
        <NavBuckets>
          {rootPage.children.map(({ title, path, children }) => (
            <Bucket key={path} partiallyActive={pagePath.indexOf(path) === 0}>
              <li>
                <SectionLink to={path}>{title}</SectionLink>
                {children.length > 1 && (
                  <ChildBucket>
                    {children.map((child) => (
                      <li key={child.path}>
                        <NavLink to={child.path} onClick={() => setPrimaryNavOpen(false)}>
                          {child.title}
                        </NavLink>
                      </li>
                    ))}
                  </ChildBucket>
                )}
              </li>
            </Bucket>
          ))}
        </NavBuckets>
        {singlePages && singlePages.length > 0 && (
          <SinglePageBucket>
            {singlePages.map(({ title, slug }) => (
              <SinglePageContainer key={slug}>
                <SectionLink to={`/${slug}`}>{title}</SectionLink>
              </SinglePageContainer>
            ))}
          </SinglePageBucket>
        )}
      </NavContainer>
    </Container>
  );
};

PrimaryNavigation.propTypes = {
  singlePages: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
  pagePath: PropTypes.string.isRequired,
};

PrimaryNavigation.defaultProps = {
  singlePages: null,
};

const PrimaryNavigationWithQuery = (props) => {
  const { contentfulNavigation } = useStaticQuery(graphql`
    query {
      contentfulNavigation(title: {eq: "Footer single pages"}) {
        links {
          title
          slug
        }
      }
    }
  `);

  return (
    <Location>
      {({ location }) => (
        <PrimaryNavigation
          singlePages={contentfulNavigation ? contentfulNavigation.links : null}
          pagePath={location.pathname}
          {...props}
        />
      )}
    </Location>
  );
};

export default PrimaryNavigationWithQuery;
